// frontend/src/components/TextInspectionModal/TextInspectionModal.jsx
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ReactDOM from 'react-dom';
import { IconButton, CircularProgress, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TextHighlighter from './TextHighlighter';
// Reuse the heatmap modal CSS for consistency
import '../HeatmapModal/HeatmapModal.css';

const TextInspectionModal = ({ isOpen, onClose, text, regions, taskName, score }) => {
  const { t } = useTranslation();
  const [processedText, setProcessedText] = useState('');
  const [isReadingFile, setIsReadingFile] = useState(false);

  // --- NEW: Handle File Objects vs Strings ---
  useEffect(() => {
    if (!text) {
      setProcessedText('');
      return;
    }

    if (typeof text === 'string') {
      // Manual input is already a string
      setProcessedText(text);
      setIsReadingFile(false);
    } else if (text instanceof File) {
      // Uploaded input is a File object, we must read it
      setIsReadingFile(true);
      const reader = new FileReader();
      reader.onload = (e) => {
        setProcessedText(e.target.result);
        setIsReadingFile(false);
      };
      reader.onerror = () => {
        console.error("Error reading file for inspection");
        setProcessedText("Error: Could not read text file content.");
        setIsReadingFile(false);
      };
      reader.readAsText(text);
    } else {
      // Fallback
      setProcessedText('');
    }
  }, [text]);

  if (!isOpen) return null;

  const modalTitle = (score !== null && score !== undefined)
    ? t('textInspection.modalTitle', { taskName, score })
    : t('textInspection.modalTitleNoScore', { taskName });

  const modalContent = (
    <div
      className="heatmap-modal-overlay open"
      onClick={onClose}
      role="dialog"
      aria-labelledby="text-inspection-modal-title"
    >
      <div className="heatmap-modal-content" onClick={(e) => e.stopPropagation()}>
        <header className="heatmap-modal-header">
          <h2 id="text-inspection-modal-title">{modalTitle}</h2>
          <IconButton
            aria-label={t('textInspection.closeAriaLabel')}
            onClick={onClose}
            className="heatmap-modal-close-button"
          >
            <CloseIcon />
          </IconButton>
        </header>

        <div className="heatmap-modal-body">
            {isReadingFile ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                    <CircularProgress color="secondary" />
                </Box>
            ) : (
                <TextHighlighter text={processedText} regions={regions} />
            )}
        </div>
      </div>
    </div>
  );
  
  return ReactDOM.createPortal(modalContent, document.body);
};

export default TextInspectionModal;